import { render, staticRenderFns } from "./FormPointByRevenue.vue?vue&type=template&id=ecb45332&scoped=true&"
import script from "./FormPointByRevenue.vue?vue&type=script&lang=js&"
export * from "./FormPointByRevenue.vue?vue&type=script&lang=js&"
import style0 from "./FormPointByRevenue.vue?vue&type=style&index=0&id=ecb45332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb45332",
  null
  
)

export default component.exports